import { forwardRef, useImperativeHandle, useMemo, useState } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { Modal } from 'antd';

import styles from './styles.module.css';
import { type IProps, type LoaderHandle } from './types';

const Loader = forwardRef<LoaderHandle, IProps>(({ innerRef }, ref) => {
  const [refs, setRefs] = useState<string[]>([]);

  const api = useMemo<LoaderHandle>(
    () => ({
      show: (nextRef: string) => {
        if (typeof nextRef !== 'string') {
          throw new Error('Loader.show needs a ref string value');
        }

        setRefs(prevRefs => (prevRefs.includes(nextRef) ? prevRefs : [...prevRefs, nextRef]));
      },
      hide: (nextRef: string) => {
        if (typeof nextRef !== 'string') {
          throw new Error('Loader.hide needs a ref string value');
        }

        setRefs(prevRefs => prevRefs.filter(item => item !== nextRef));
      }
    }),
    []
  );

  useImperativeHandle(ref, () => api, [api]);
  useImperativeHandle(innerRef, () => api, [api]);

  return (
    <Modal
      open={!!refs.length}
      footer={null}
      closable={false}
      keyboard={false}
      maskClosable={false}
      centered
      className={styles.modal}
    >
      <div id='modal-loader'>
        <LoadingOutlined className={styles.loader} spin />
      </div>
    </Modal>
  );
});

export default Loader;
